var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectronicFrontierFoundation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "4.2 138.1 1192.8 219.8",
    style: {
      enableBackground: "new 4.2 138.1 1192.8 219.8"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B6A88;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.8,139.1h21v9.5h-11.9V165h8.5v10.1h-8.5v17.2h11.9v9.1h-21V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.7,139.1h9.1v54h12.1v8.3h-21.3L332.7,139.1L332.7,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.8,139.1h21v9.5h-11.9V165h8.5v10.1h-8.5v17.2h11.9v9.1h-21V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409,180v8.5c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-36.8c0-2.4,0.6-4.7,1.6-6.7c0.8-1.8,1.8-3.4,3.6-4.7c1.8-1.2,4.2-2.2,7.1-2.2 c3,0,5.3,0.8,7.1,2.2c1.8,1.2,3,3,3.6,4.7c1,2,1.4,4.2,1.6,6.7v8.5h-8.5v-8.5c0-1.8-0.4-3-1.4-4c-0.4-0.4-1.2-0.6-2.2-0.6 c-1.6,0-2.4,1.2-2.8,2.4c-0.2,0.6-0.4,1.4-0.4,2.4v36.8c0,1.8,0.6,3,1.4,4c0.4,0.4,1,0.6,1.8,0.6c2,0,2.8-1,3.2-2.4 c0.2-0.6,0.4-1.4,0.4-2.4V180H409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.8,148.4v-9.3h26.5v9.5h-8.7v52.8h-9.1v-53H411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.7,201.4l-4.7-26.3h-2.4v26.3h-9.1v-62.3h9.1c10.9,0,15.6,6.1,15.6,18c0,6.1-1.6,11.9-5.1,14.2l5.9,30.2 h-9.3V201.4z M451.5,166.6c1.2,0,3-0.2,4.3-1.4c1.4-1.2,2.4-3.6,2.4-7.9s-1.2-6.7-2.4-7.9c-1.4-1.2-3-1.2-4.3-1.2V166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.2,188.5c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-36.8c0-2.4,0.6-4.7,1.6-6.7c0.8-1.8,1.8-3.4,3.6-4.7c1.8-1.2,4.2-2.2,7.1-2.2 c3,0,5.3,0.8,7.1,2.2c1.8,1.2,3,3,3.6,4.7c1,2,1.4,4.2,1.6,6.7V188.5z M488.1,151.8c0-1.8-0.4-3-1.2-4c-0.4-0.4-1.2-0.6-1.8-0.6 c-1.6,0-2.4,1.2-2.8,2.4c-0.2,0.6-0.4,1.4-0.4,2.4v36.8c0,1.8,0.4,3,1.2,4c0.4,0.4,1,0.6,1.8,0.6c1.6,0,2.4-1,2.8-2.4 c0.2-0.6,0.4-1.4,0.4-2.4V151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.6,168.9l-0.8-3h-0.6v35.5h-8.5v-62.3h8.1l8.9,32.4l0.8,3h0.6v-35.4h8.5v62.3h-8.1L513.6,168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537.7,139.1h9.1v62.3h-9.1V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578.1,180v8.5c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-36.8c0-2.4,0.6-4.7,1.6-6.7c0.8-1.8,1.8-3.4,3.6-4.7c1.8-1.2,4.2-2.2,7.1-2.2 c3,0,5.3,0.8,7.1,2.2c1.8,1.2,3,3,3.6,4.7c1,2,1.4,4.2,1.6,6.7v8.5h-8.5v-8.5c0-1.8-0.4-3-1.4-4c-0.4-0.4-1.2-0.6-2.2-0.6 c-1.6,0-2.4,1.2-2.8,2.4c-0.2,0.6-0.4,1.4-0.4,2.4v36.8c0,1.8,0.6,3,1.4,4c0.4,0.4,1,0.6,1.8,0.6c2,0,2.8-1,3.2-2.4 c0.2-0.6,0.4-1.4,0.4-2.4V180H578.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.8,226.5h-11.9v16.4h8.5v9.5h-8.5v27.1h-9.1V217h21V226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.1,279.5l-4.7-26.3H342v26.3h-9.1V217h9.1c10.9,0,15.6,6.1,15.6,18c0,6.1-1.6,11.9-5.1,14.2l5.9,30.2 L349.1,279.5L349.1,279.5z M342,244.5c1.2,0,3-0.2,4.3-1.4c1.4-1.2,2.4-3.6,2.4-7.9s-1.2-6.7-2.4-7.9c-1.4-1.2-3-1.2-4.3-1.2V244.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.7,266.6c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-36.8c0-2.4,0.6-4.7,1.6-6.7c0.8-1.8,1.8-3.4,3.6-4.7c1.8-1.2,4.2-2.2,7.1-2.2 c3,0,5.3,0.8,7.1,2.2c1.8,1.2,3,3,3.6,4.7c1,2,1.4,4.2,1.6,6.7V266.6z M378.6,229.8c0-1.8-0.4-3-1.2-4c-0.4-0.4-1.2-0.6-1.8-0.6 c-1.6,0-2.4,1.2-2.8,2.4c-0.2,0.6-0.4,1.4-0.4,2.4v36.6c0,1.8,0.4,3,1.2,4c0.4,0.4,1,0.6,1.8,0.6c1.6,0,2.4-1,2.8-2.4 c0.2-0.6,0.4-1.4,0.4-2.4V229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.1,246.8l-0.8-3h-0.6v35.4h-8.5v-62.3h8.1l8.9,32.4l0.8,3h0.6v-35.4h8.5v62.5H413L404.1,246.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.1,226.5V217h26.5v9.5h-8.7v53h-9.1v-53H425.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.5,217h9.1v62.5h-9.1V217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.9,217h21v9.5H481v16.4h8.5v9.9H481V270h11.9v9.5h-21V217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.8,279.5l-4.7-26.3h-2.4v26.3h-9.3V217h9.1c10.9,0,15.6,6.1,15.6,18c0,6.1-1.6,11.9-5.1,14.2l5.9,30.2 L514.8,279.5L514.8,279.5z M507.7,244.5c1.2,0,3-0.2,4.3-1.4c1.4-1.2,2.4-3.6,2.4-7.9s-1.2-6.7-2.4-7.9c-1.4-1.2-3-1.2-4.3-1.2 V244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.8,304.4h-11.9v16.4h8.5v9.5h-8.5v27.1h-9.1v-62.5h21V304.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.7,344.5c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-36.8c0-2.4,0.6-4.7,1.6-6.7c0.8-1.8,1.8-3.4,3.6-4.7c1.8-1.2,4.2-2.2,7.1-2.2 c3,0,5.3,0.8,7.1,2.2c1.8,1.2,3,3,3.6,4.7c1,2,1.4,4.2,1.6,6.7V344.5z M347.6,307.7c0-1.8-0.4-3-1.2-4c-0.4-0.4-1.2-0.6-1.8-0.6 c-1.6,0-2.4,1.2-2.8,2.4c-0.2,0.6-0.4,1.4-0.4,2.4v36.8c0,1.8,0.4,3,1.2,4c0.4,0.4,1,0.6,1.8,0.6c1.6,0,2.4-1,2.8-2.4 c0.2-0.6,0.4-1.4,0.4-2.4V307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.7,294.9v49.6c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-49.6h9.1v49.6c0,1.8,0.4,3,1.2,4c0.4,0.4,1,0.6,1.8,0.6c1.6,0,2.4-1,2.8-2.4 c0.2-0.6,0.4-1.4,0.4-2.4v-49.4L387.7,294.9L387.7,294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.5,324.7l-0.8-3h-0.6v35.4h-8.5v-62.3h8.1l8.9,32.4l0.8,3h0.6v-35.4h8.5v62.5h-8.1L404.5,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.8,357.3v-62.5h7.3c8.5,0,13,1.8,15.6,6.5c2.4,4.7,2.8,12.7,2.8,24.7c0,12.3-0.4,20-2.8,24.7 s-7.1,6.5-15.6,6.5C436.1,357.3,428.8,357.3,428.8,357.3z M437.9,348c3.2,0,4.9-0.4,5.9-3.4c0.4-1.4,0.8-3.6,0.8-6.7 c0-3,0-6.9,0-12.1s0-9.1,0-12.1s-0.4-5.1-0.8-6.7c-1-3-2.8-3.4-5.9-3.4V348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.5,357.3l9.5-62.5h11.3l9.5,62.5h-9.1l-1.8-12.7H468l-1.8,12.7H457.5z M473.1,315.2l-0.2-1.6h-0.6 l-0.2,1.6l-2.6,19.8h6.3L473.1,315.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.3,304.4v-9.5h26.5v9.5h-8.7v53H495v-53H486.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.2,294.9h9.1v62.5h-9.1V294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.3,344.5c0,2.6-0.6,4.7-1.6,6.7c-0.8,1.8-2,3.4-3.6,4.5c-1.8,1.4-4,2.2-7.1,2.2c-3,0-5.3-0.8-7.1-2.2 c-1.8-1.2-2.8-3-3.6-4.5c-1-2-1.4-4.2-1.6-6.7v-36.8c0-2.4,0.6-4.7,1.6-6.7c0.8-1.8,1.8-3.4,3.6-4.7c1.8-1.2,4.2-2.2,7.1-2.2 s5.3,0.8,7.1,2.2c1.8,1.2,3,3,3.6,4.7c1,2,1.4,4.2,1.6,6.7V344.5z M549.2,307.7c0-1.8-0.4-3-1.2-4c-0.4-0.4-1.2-0.6-1.8-0.6 c-1.6,0-2.4,1.2-2.8,2.4c-0.2,0.6-0.4,1.4-0.4,2.4v36.8c0,1.8,0.4,3,1.2,4c0.4,0.4,1,0.6,1.8,0.6c1.6,0,2.4-1,2.8-2.4 c0.2-0.6,0.4-1.4,0.4-2.4V307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M574.7,324.7l-0.8-3h-0.6v35.4h-8.5v-62.3h8.1l8.9,32.4l0.8,3h0.6v-35.4h8.5v62.5h-8.1L574.7,324.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.2,139.1 4.2,357.3 291.2,357.3 291.2,294.9 97.7,294.9 97.7,279.3 291.2,279.3 291.2,217 97.7,217 97.7,201.4 291.2,201.4 291.2,139.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "607.3,139.1 607.3,357.3 700.8,357.3 700.8,279.3 894.3,279.3 894.3,217 700.8,217 700.8,201.4 894.3,201.4 894.3,139.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "910,139.1 910,357.3 1003.5,357.3 1003.5,279.3 1197,279.3 1197,217 1003.5,217 1003.5,201.4 1197,201.4 1197,139.1  "
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectronicFrontierFoundation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/electronic-frontier-foundation.3c599607e064ff97b1de068af57d8da1.svg";